import axios, {AxiosResponse} from "axios";
import config from "../config";
import store from "../store/store";

function wrap<T>(request: Promise<AxiosResponse<any>>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    request.then(result => {
      if (result.data?.success === false) {
        reject(result.data.error);
        return;
      }

      if (result.data?.success === true && result.data.result !== undefined) {
        resolve(result.data.result)
        return;
      }

      resolve(result.data);
    }).catch(reason => {
      reject(reason.response?.data?.error ?? reason.message);
    })
  });
}

function getHeaders() {
  let headers: any = {};

  let apiToken = store.getState().AuthState.authToken;
  if (apiToken)
    headers["Authorization"] = "Bearer " + apiToken;

  return headers;
}

function getUrl(path: string) {
  const s = config.apiHost.includes('localhost') ? "" : "s";
  return `http${s}://${config.apiHost}${path}`
}

export const ApiService = {
  post: <T>(path: string, body: any): Promise<T> => wrap<T>(axios.post(getUrl(path), body, {headers: getHeaders()})),
  get: <T>(path: string): Promise<T> => wrap<T>(axios.get(getUrl(path), {headers: getHeaders()})),
}
